export default "__VITE_ASSET__DYRyrI5___"